<template>
    <b-table hover small responsive show-empty class="sr-caption"
             aria-live="polite"
             :id="slug"
             :fields="fields"
             :items="items"
             primary-key="id"
             :busy="isLoading"
             label-sort-asc=""
             label-sort-desc=""
             >
        <template v-slot:cell(actions)="row">
            <b-button size="sm"
                      variant="primary"
                      class="mr-1"
                      @click="downloadAttachment(row)"
                      target="_attach"
            >
                Download
            </b-button>
        </template>

        <template v-slot:empty="scope">
            <p>No other names found.</p>
        </template>

        <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"
                       label="Loading, Please Wait" aria-label="Loading, Please Wait"></b-spinner>
            <strong>Loading, Please Wait...</strong>
        </div>
    </b-table>
</template>

<script>
    import axios from 'axios';
    export default {
        name: "OtherNames.vue",
        components:{},
        props:{
            items: Array,
            slug:[String],
            isLoading: Boolean
        },
        data:()=>({
            fields:[
                {key: 'lastName',label:'Last Name',sortable:true},
                {key:'firstName',label:'First Name',sortable: true},
                {key:'middleName',label:'Middle Name',sortable:true},
                {key:'status.description',label:'Status',sortable:true},
                {key:'actions',label:'Attachment'}
            ]
        }),
        methods:{
            downloadAttachment(row){
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/attachments/getUrl/`+row.item.attachment.id)
                    .then(response=>{
                        window.open(response.data,"_blank");
                    })
            }
        }
    }
</script>

<style scoped>

</style>